export default "/images/folder-plus.svg?e573ef14703afc7d66f1891ca9c0ca0e";